/**
 * @generated SignedSource<<50e9e32dbcbaaefbfcad73154440c516>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SpecialTextType = "EMAIL" | "TEL" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ContactForm_contactForm$data = {
  readonly formItems: ReadonlyArray<{
    readonly __typename: "FormItemGroup";
    readonly items: ReadonlyArray<{
      readonly __typename: "MultiLineText";
      readonly label: string | null | undefined;
      readonly name: string;
      readonly required: boolean;
    } | {
      readonly __typename: "RadioGroup";
      readonly name: string;
      readonly options: ReadonlyArray<{
        readonly attached: {
          readonly __typename: "MultiLineText";
          readonly label: string | null | undefined;
          readonly name: string;
          readonly required: boolean;
        } | {
          readonly __typename: "SingleLineText";
          readonly label: string | null | undefined;
          readonly name: string;
          readonly required: boolean;
          readonly special: SpecialTextType | null | undefined;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
        readonly label: string;
        readonly value: string;
      }>;
      readonly required: boolean;
    } | {
      readonly __typename: "SingleLineText";
      readonly label: string | null | undefined;
      readonly name: string;
      readonly required: boolean;
      readonly special: SpecialTextType | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }>;
    readonly title: string | null | undefined;
  } | {
    readonly __typename: "MultiLineText";
    readonly label: string | null | undefined;
    readonly name: string;
    readonly required: boolean;
  } | {
    readonly __typename: "RadioGroup";
    readonly name: string;
    readonly options: ReadonlyArray<{
      readonly attached: {
        readonly __typename: "MultiLineText";
        readonly label: string | null | undefined;
        readonly name: string;
        readonly required: boolean;
      } | {
        readonly __typename: "SingleLineText";
        readonly label: string | null | undefined;
        readonly name: string;
        readonly required: boolean;
        readonly special: SpecialTextType | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
      readonly label: string;
      readonly value: string;
    }>;
    readonly required: boolean;
  } | {
    readonly __typename: "SingleLineText";
    readonly label: string | null | undefined;
    readonly name: string;
    readonly required: boolean;
    readonly special: SpecialTextType | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }>;
  readonly header: string;
  readonly submitButtonLabel: string;
  readonly text: string;
  readonly " $fragmentType": "ContactForm_contactForm";
};
export type ContactForm_contactForm$key = {
  readonly " $data"?: ContactForm_contactForm$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContactForm_contactForm">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "required",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "special",
      "storageKey": null
    }
  ],
  "type": "SingleLineText",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "type": "MultiLineText",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RadioOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "attached",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "type": "RadioGroup",
  "abstractKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactForm_contactForm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formItems",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v6/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "FormItemGroup",
          "abstractKey": null
        },
        (v6/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submitButtonLabel",
      "storageKey": null
    }
  ],
  "type": "ContactForm",
  "abstractKey": null
};
})();

(node as any).hash = "e956cef36fd34dbc566284222f8c3c58";

export default node;
